import React from 'react';
import { Link } from 'react-router-dom';
import { ROUTE_PATHS } from '../config/constants';

const NotFound = () => {
  return (
    <div className="container py-5 text-center">
      <h1 className="mb-3">Página no encontrada</h1>
      <p className="text-muted mb-4">
        La URL que buscas no existe o ha cambiado.
      </p>
      <div className="d-flex justify-content-center gap-3 flex-wrap">
        <Link to={ROUTE_PATHS.HOME} className="btn btn-primary">
          Ir al inicio
        </Link>
        <Link to={ROUTE_PATHS.ADMIN} className="btn btn-outline-primary">
          Acceso admin
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
